var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1633 244",
    width: 1633,
    height: 244,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CN_logo_horizontal_blueIcon_blackName_RGB-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #231f20 } \n\t\t.s1 { fill: #003d79 } \n\t\t.s2 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clear_Space_Horizontal"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TM__x28_Avenir_LT_Std_14.96_pt_x29_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1592.5 119.2h-2.8v-24.7h-9v-2.6h21.1v2.6h-9v24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1619.3 114.3l9.3-22.1h4.1v27.2h-2.8v-23.6l-9.8 23.6h-1.5l-9.8-23.6v23.6h-2.9v-27.2h4.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "CN_Name_Horizontal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m309.3 143.6v-0.2c0-26.8 20.1-48.9 48.7-48.9 17.5 0 28.1 6.2 37.1 14.7l-10.5 12.3c-7.5-6.9-15.8-11.8-26.6-11.8-18 0-31.2 14.9-31.2 33.4v0.3c0 18.5 13.2 33.4 31.2 33.4 11.6 0 19.1-4.6 27.1-12.1l10.5 10.8c-9.7 10.3-20.6 16.8-38.4 16.8-27.3 0-47.9-21.7-47.9-48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m403.4 170.1v-0.2c0-15.5 12.1-22.9 29.4-22.9 7.9 0 13.6 1.3 19.3 3.1v-1.8c0-10.1-6.2-15.5-17.8-15.5-8 0-13.9 1.8-20.4 4.4l-4.3-12.9c7.7-3.6 15.4-5.9 26.8-5.9 10.5 0 18.5 2.8 23.7 8 5.1 5.1 7.7 12.6 7.7 22.1v42.2h-16v-9c-4.9 5.9-12.3 10.3-23.2 10.3-13.4 0-25.2-7.7-25.2-21.9zm48.9-5.1v-4.9c-4.1-1.5-9.7-2.8-16.2-2.8-10.6 0-16.7 4.3-16.7 11.8v0.3c0 6.9 6.1 10.8 13.9 10.8 10.8 0 19-6.2 19-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m483.8 119.2h16.2v10.8c4.7-6.4 10.8-12.4 21.7-12.4 10.3 0 17.5 4.9 21.4 12.6 5.6-7.4 13.1-12.6 23.9-12.6 15.5 0 25 9.8 25 27.3v45.6h-16.2v-40.4c0-11.4-5.2-17.5-14.4-17.5-9.1 0-15.2 6.1-15.2 17.7v40.2h-16.3v-40.7c0-11.1-5.4-17.2-14.4-17.2-9 0-15.2 6.7-15.2 17.7v40.2h-16.3v-71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m625.3 179.4v11.1h-16.3v-98.6h16.3v39.1c5.1-7.4 12.6-13.4 24.2-13.4 16.8 0 33.3 13.2 33.3 37.1v0.2c0 23.7-16.3 37.1-33.3 37.1-11.8 0-19.3-5.9-24.2-12.6zm40.7-24.5v-0.2c0-13.9-9.3-22.9-20.4-22.9-11 0-20.8 9.3-20.8 22.9v0.2c0 13.7 9.8 22.9 20.8 22.9 11.4 0 20.4-8.7 20.4-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m696.4 92.9h17.5v15.5h-17.5zm0.5 26.2h16.5v71.3h-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m730.4 164.7v-45.3h16.3v40.4c0 11.1 5.6 17.3 15.2 17.3 9.5 0 16-6.5 16-17.5v-40.2h16.5v71.3h-16.5v-11.1c-4.7 6.7-11.4 12.7-22.5 12.7-15.7-0.3-25-11.1-25-27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m811.6 119.2h16.3v10.8c4.6-6.4 10.8-12.4 21.6-12.4 10.3 0 17.5 4.9 21.4 12.6 5.7-7.4 13.1-12.6 24-12.6 15.4 0 25 9.8 25 27.3v45.6h-16.3v-40.4c0-11.4-5.1-17.5-14.4-17.5-9 0-15.2 6.1-15.2 17.7v40.2h-16.2v-40.7c0-11.1-5.5-17.2-14.5-17.2-9 0-15.2 6.7-15.2 17.7v40.2h-16.2v-71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m975.5 96h15.5l50.8 65.4v-65.4h16.5v94.5h-14l-52.3-67.2v67.2h-16.2v-94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1073 155.2v-0.3c0-20.3 14.4-37 34.7-37 22.7 0 34.3 17.8 34.3 38.3 0 1.6-0.2 3.1-0.2 4.7h-52.6c1.8 11.5 10 18 20.6 18 8 0 13.7-3.1 19.3-8.5l9.6 8.5c-6.7 8-16 13.4-29.1 13.4-20.7 0-36.6-15-36.6-37.1zm52.8-5.4c-1-10.5-7.2-18.8-18.1-18.8-10 0-17 7.7-18.5 18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1158.5 170.9v-37.6h-9v-14.1h9v-19.6h16.5v19.6h19.1v14.1h-19.1v35c0 6.5 3.4 9 8.8 9q5.4 0 10-2.3v13.4c-4.1 2.3-8.5 3.6-14.7 3.6-12.1-0.3-20.6-5.4-20.6-21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1201.3 119.2h16.8l14.4 48.9 15.7-49.2h14.2l15.7 49.2 14.7-48.9h16.5l-23.5 71.8h-14.7l-15.9-48.7-16 48.7h-14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1312.6 155.2v-0.3c0-20.3 16.3-37.3 38.2-37.3 21.9 0 37.9 16.8 37.9 37.1v0.2c0 20.4-16.3 37.1-38.4 37.1-21.4 0.3-37.7-16.5-37.7-36.8zm59.8 0v-0.3c0-12.6-9-22.9-21.9-22.9-13.1 0-21.4 10.3-21.4 22.7v0.2c0 12.4 9.1 22.9 21.7 22.9 13.4 0 21.6-10.2 21.6-22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1402.1 119.2h16.5v15.9c4.4-10.5 12.6-18 25.2-17.5v17.3h-1c-14.4 0-24.2 9.2-24.2 28.3v27h-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1454.4 91.9h16.2v58.9l29.7-31.6h19.8l-28.3 29.1 29.3 42.2h-19.3l-21.1-30.9-10.1 10.5v20.4h-16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1523.7 181.2l7.2-11.1c7.8 5.9 16 8.8 23.5 8.8 7 0 11.1-3.1 11.1-7.7v-0.3c0-5.7-7.5-7.5-16-10-10.6-3.1-22.4-7.2-22.4-20.9v-0.2c0-13.4 11.3-21.6 25.5-21.6 9 0 18.5 3 26.3 7.9l-6.5 11.6c-6.9-4.1-14.1-6.7-20.1-6.7-6.4 0-10 3.1-10 7v0.2c0 5.2 7.7 7.5 16 10.1 10.3 3.3 22.1 7.9 22.1 20.8v0.3c0 14.9-11.6 22.3-26.5 22.3-10.1 0.3-21.2-3.3-30.2-10.5z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "CN_Icon_Horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m197.2 54.9c10.8 0 21.4 2.5 30.9 7.2 10.3 17.5 16 38 16 59.9 0 26-8.2 50.2-22.2 70-7.7 2.8-15.9 4.4-24.4 4.4-25.8 0-49.5-13.9-62.2-36.3-9.2-16.5-11.6-35.5-6.4-53.8 4.9-18 17-33.2 33.5-42.4 10.6-6 22.4-9 34.8-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.3 9.1c13.2-5.4 27.6-8.5 42.5-8.8-52.5 33.2-70.3 102.2-39.6 157q5 9.2 11.6 16.9c-9.8-8.7-18.1-19-24.5-30.6-24.8-44-19.1-96.7 10-134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m173.5 221.6c6.9 0 13.9-0.5 20.6-1.6-20.1 15-45.1 23.7-72.2 23.7-67.2 0-121.9-54.5-121.9-121.7 0-39.9 19.4-75.4 49-97.5-18.8 38.9-18.8 86.2 3.9 126.6 24.4 43.5 70.6 70.5 120.6 70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m189.7 27.3c3.4 0 6.7 0.3 9.8 0.5 4.9 3.9 9.3 8.3 13.4 12.9-5.1-1-10.6-1.5-16-1.5-14.7 0-29.1 3.8-42 11-20.1 11.1-34.8 29.6-41 51.7-5.4 19.6-3.8 39.9 4.2 58.2-1.1-1.8-2.1-3.4-3.1-5.2-11.4-19.8-13.9-42.9-7.8-65 6.2-21.9 20.7-40.4 40.8-51.5 12.6-7.2 27.3-10.8 41.7-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m132 10.1c5.1-2.8 10.6-5.2 16-7.2 10 2.3 19.6 5.6 28.3 10-12.6 1.8-25 5.9-36.1 12.1-23.4 13.1-40.4 34.8-47.9 60.7-7.5 26-4.1 53.3 9 77 0.3 0.5 0.8 1 1 1.5-3.6-4.4-6.9-9.3-9.7-14.4-27.6-49.4-9.8-111.9 39.4-139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m193.1 220c-6.7 1.1-13.7 1.6-20.6 1.6-50 0-96.2-27-120.7-70.5-22.6-40.4-22.4-87.5-3.8-126.6 8.2-6.4 17.5-11.6 27.3-15.4-28.9 37.8-34.5 90.5-9.8 134.5 6.7 11.6 14.9 21.9 24.5 30.6q-6.6-8.1-11.6-16.9c-30.7-54.8-12.6-123.8 39.7-157q1.5 0 3.1 0c9 0 17.7 1 26.3 2.8-5.5 2.1-10.9 4.4-16 7.3-49.5 27.7-67 90.3-39.5 139.7 2.9 5.1 6.2 10 9.8 14.4-0.2-0.5-0.7-1.1-1-1.6-13.1-23.6-16.5-50.9-9-76.9 7.2-26 24.2-47.6 47.9-60.7 11.4-6.5 23.5-10.3 36.1-12.1 8.2 4.1 16.2 9 23.2 14.9-3.4-0.3-6.4-0.5-9.8-0.5-14.4 0-28.9 3.8-41.7 11.1-20.2 11-34.6 29.3-40.8 51.4-6.2 21.9-3.3 45 7.8 65.1 1 1.8 2 3.6 3.1 5.2-8.3-18.3-9.6-38.6-4.2-58.2 6.5-22.1 20.9-40.4 41-51.7 12.9-7.2 27.3-11.1 42-11.1 5.4 0 10.8 0.5 16 1.6 5.9 6.4 10.8 13.6 15.2 21.1-9.5-4.7-20.1-7.2-30.9-7.2-12.1 0-24 3-34.6 9-16.5 9.2-28.3 24.2-33.5 42.4-5.1 18.3-2.8 37.3 6.5 53.8 12.6 22.4 36.3 36.3 62.1 36.3 8.2 0 16.5-1.6 24.5-4.4-7.8 10.8-17 20.3-28.6 28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.029dc31823ba0c89bc8e876b1c417716.svg";
export { ForwardRef as ReactComponent };